import { LookupValue } from "../data/lookup-value";
import { InvestmentYear } from "./investment-year";
import { LookupItem } from "./lookup-item";

export class OwnershipModel {
  name: string = "";
  country: LookupValue | null = null;
  industry: LookupItem | null = null;
  ownershipInterest: LookupItem | null = null;
  position: string = "";
  dateStart: string = "";
  years: InvestmentYear[] = [
    new InvestmentYear(),
    new InvestmentYear(),
    new InvestmentYear(),
    new InvestmentYear()];
}